__webpack_require__.p = "https://static.age.awaze.com/search-mfe/0652f0e/_next/";